// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LjT3npHVQ8xt7TfD8Xj9{box-sizing:border-box;box-shadow:inset 0 0 0 1px var(--border-neutral-default);background:var(--background-primary-inverted-primary);border-radius:6px;align-items:center;gap:4px;padding:4px 4px 4px 8px;display:inline-flex}.LjT3npHVQ8xt7TfD8Xj9.I9O3maZ6mETUIE7H_ZZD{box-shadow:none;background:var(--black-10)}.LjT3npHVQ8xt7TfD8Xj9 .XhRUOsnsyXUm7Gwkq7c6{cursor:pointer}.LjT3npHVQ8xt7TfD8Xj9 .JL7vooerA98tIok5NgPI{width:16px;height:16px}.LjT3npHVQ8xt7TfD8Xj9.KGM4hZa9tmg83mcRY2n8{padding-right:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `LjT3npHVQ8xt7TfD8Xj9`,
	"secondary": `I9O3maZ6mETUIE7H_ZZD`,
	"clickable": `XhRUOsnsyXUm7Gwkq7c6`,
	"icon": `JL7vooerA98tIok5NgPI`,
	"withoutDelete": `KGM4hZa9tmg83mcRY2n8`
};
export default ___CSS_LOADER_EXPORT___;
